/* eslint-disable @typescript-eslint/naming-convention */
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  FormControlLabel,
  Grid,
  InputAdornment,
  TextField,
  Tooltip,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
  Divider,
} from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import moment from 'moment';
import * as React from 'react';
import { DateRange } from 'react-date-range';
import { casesApi } from 'src/api/casesApi';
import { Drawer } from '@mui/material';
import {
  fontSize,
  fontWeight,
  margin,
  padding,
  width,
} from '@material-ui/system';
import { useCallback, useEffect, useRef, useState } from 'react';
import { pimApis } from 'src/api/pim';
import toast from 'react-hot-toast';

import CloseIcon from '@mui/icons-material/Close';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

const catagoryFeilds = [
  {
    label: 'SKU',
    index: 0,
    checked: true,
    inputType: 'string',
    isMandatory: true,
  },
  {
    label: 'Name',
    index: 1,
    checked: true,
    inputType: 'string',
    isMandatory: true,
  },
  {
    label: 'Currency',
    index: 2,
    checked: false,
    inputType: 'string',
    isMandatory: true,
  },
  {
    label: 'Monthly MSRP',
    index: 3,
    checked: false,
    inputType: 'double',
    isMandatory: true,
  },
  {
    label: '1-Year MSRP (Revenue per year)',
    index: 4,
    checked: false,
    inputType: 'double',
    isMandatory: true,
  },
  {
    label: '3-Year MSRP',
    index: 5,
    checked: false,
    inputType: 'double',
    isMandatory: true,
  },
  {
    label: 'Product Line (Product categories)',
    index: 6,
    checked: false,
    inputType: 'string',
    isMandatory: true,
  },
  {
    label: '# of Sockets',
    index: 7,
    checked: false,
    inputType: 'int',
    isMandatory: true,
  },
  {
    label: '# of Cores',
    index: 8,
    checked: false,
    inputType: 'int',
    isMandatory: true,
  },
  {
    label: '# of Nodes',
    index: 9,
    checked: false,
    inputType: 'int',
    isMandatory: true,
  },
  {
    label: 'Support Type',
    index: 10,
    checked: false,
    inputType: 'string',
    isMandatory: true,
  },
  {
    label: 'Virtual Guests',
    index: 11,
    checked: false,
    inputType: 'string',
    isMandatory: true,
  },
  {
    label: 'System Unit of Measure',
    index: 12,
    checked: false,
    inputType: 'string',
    isMandatory: true,
  },
  {
    label: 'Distributor',
    index: 13,
    checked: false,
    inputType: 'string',
    isMandatory: true,
  },
  {
    label: 'Supplier',
    index: 14,
    checked: false,
    inputType: 'string',
    isMandatory: true,
  },
];

const useStyles = makeStyles(() =>
  createStyles({
    createFormSideBar: {
      width: '30%',
      border: 'none',
      '& .ticketBody': {
        height: '90vh',
        overflowY: 'auto',
        padding: '5px 20px',
        '& input': {
          borderRadius: '2px',
          padding: '8px',
        },
        '& .select': {
          minHeight: '22px !important',
          padding: '0 10px',
          lineHeight: '116.7%',
          color: '#696969',
          width: '100%',
          '& .MuiAutocomplete-input': {
            minHeight: '38px !important',
            padding: 0,
          },
        },
      },
      '& .skuName': {
        '& .Mui-checked': {
          color: '#c1c1c1',
        },
      },
      '& .noData': {
        margin: '0px 0px 0px 17px',
        fontSize: '16px',
      },
      '& .BoxText': {
        marginBottom: '20px',

        '& p': {
          margin: '0px',
        },
        '& .heading': {
          fontSize: '13px',
          color: '#425466',
          margin: '0px',
          fontWeight: '600',
        },
        '& .description': {
          fontSize: '14px',
          color: '#B5B5BD',
          margin: '0px',
          fontWeight: '600',
        },
      },
      '& h4': {
        background: '#C22027',
        color: '#fff',
        padding: '10px 40px',
        margin: '-5px -20px 30px',
        height: '64px',
        display: 'flex',
        alignItems: 'center',
      },
      '& label': {
        letterSpacing: ' 0.15px',
        color: '#231F20',
        fontWeight: '600',
        fontSize: '12px',
        display: 'block',
      },
      '&    .MuiDivider-root': {
        paddingTop: '12px',
      },
      '& .CheckboxesSection': {
        marginTop: '15px',
        '& .MuiCheckbox-root': {
          padding: '0px 7px 0px 0px',
        },
        '& .MuiFormControlLabel-label': {
          fontSize: '13px',
          color: '#667085',
        },
        '& label': {
          margin: '0px 0px 0px 0px',
          top: '0px',
          backgroundColor: 'white',
          padding: '2px',
        },
      },
      '& .selectField': {
        '& label': {
          top: '0px',
          backgroundColor: 'white',
          padding: '4px',
        },
      },
      '& .customFieldSection': {
        '& .customField': {
          paddingTop: '5px',
        },
        '& .MuiGrid-item': {
          '&:nth-child(1)': {
            paddingTop: '8px',
          },
        },

        '& .MuiSelect-select': {
          padding: '8px',
        },
        '& .addCustomFieldBT': {
          padding: '0px !important',
          backgroundColor: 'transparent',
          color: '#EE3235',
          boxShadow: 'none',
          fontSize: '12px',
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },

      //
    },
    advancedFilter: {
      '& .fields+.fields': {
        marginTop: '15px',
      },
      '& .datefield': {
        position: 'relative',
        '& .rdrCalendarWrapper': {
          zIndex: '999',
          position: 'absolute',
          right: '-1px',
          borderRadius: '5px',
          border: '1px solid rgb(239, 242, 247)',
          '& .rdrDateDisplayWrapper': {
            borderTopLeftRadius: '5px',
            borderTopRightRadius: '5px',
          },
        },
      },
    },
    datePicker: {
      zIndex: '999',
      position: 'absolute',
      borderRadius: '5px',
    },
  })
);
const validationSchema = Yup.object().shape({
  name: Yup.string().trim('')
    .required('Name is required')
    .min(2, 'Name must be at least 2 characters')
    .max(50, 'Name must not exceed 50 characters')
    .matches(
      /^[a-zA-Z0-9\s-_]+$/,
      'Name can only contain letters, numbers, spaces, hyphens and underscores'
    ),
  // description: Yup.string()
  //   .required('Description is required')
  //   .min(10, 'Description must be at least 10 characters')
  //   .max(500, 'Description must not exceed 500 characters'),
});

export default function CatagoryDrawer(props: any) {
  const { open, onClose, onSubmit, initialValues, title, editCategory } = props;

  const [categoriesData, setCategoriesData] = useState(catagoryFeilds);
  const classes: any = useStyles();

  const [cateFields, setCateFields] = useState({
    name: '',
    description: '',
  });

  const [customField, setCustomField] = useState({
    title: '',
    inputType: 'String',
    mandatory: 'Yes',
  });

  const addCustomField = () => {
    const trimmedTitle = customField.title.trim();

    if (!trimmedTitle) {
      toast.error('Custom Field Title cannot be empty.');
      return;
    }
    const fieldExists = categoriesData.some(
      (field) => field.label.toLowerCase() === customField.title.toLowerCase()
    );

    if (fieldExists) {
      toast.error('Field with the same title already exists');
      return;
    }
    let chk;

    if (customField.title && customField.inputType && customField.mandatory) {
      if (customField.mandatory === 'No') {
        chk = false;
      } else {
        chk = true;
      }
      const newCustomField: any = {
        label: `${customField.title}`,
        index: categoriesData.length,
        checked: false,
        isMandatory: chk,
        inputType: customField.inputType,
      };
      setCategoriesData((prev) => [...prev, newCustomField]);
      setCustomField({ title: '', inputType: 'String', mandatory: 'Yes' });
      // toast.success('Field added successfully');
    }
  };

  const handleInputChange = (field: string, value: any) => {
    setCateFields((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleClose = () => {
    setCateFields({
      name: '',
      description: '',
    });

    setCategoriesData(catagoryFeilds); // Reset to the original category fields

    setCustomField({
      title: '',
      inputType: 'String',
      mandatory: 'Yes',
    });

    onClose();
  };

  const getProductHeader = async (prodTempId) => {
    try {
      const res = await pimApis.getProductHeader(prodTempId);
      const templateDataa = res.data; // Use the response directly

      if (templateDataa?.fields) {
        const updatedData = catagoryFeilds.map((field) => {
          const matchingTemplate = templateDataa.fields.find(
            (template) =>
              template.name.trim().toLowerCase() ===
              field.label.trim().toLowerCase()
          );
          return {
            ...field,
            checked: !!matchingTemplate,
          };
        });

        /* eslint-disable no-undef */
        const newCustomFields = templateDataa.fields.filter(
          (template) =>
            !catagoryFeilds.some(
              (field) =>
                field.label.trim().toLowerCase() ===
                template.name.trim().toLowerCase()
            )
        );

        const formattedCustomFields = newCustomFields.map((field, index) => ({
          label: field.name,
          index: catagoryFeilds.length + index,
          checked: true,
          isMandatory: field.isMandatory,
          inputType: field.fieldType,
        }));

        const finalData = [...updatedData, ...formattedCustomFields];

        setCategoriesData(finalData); // Update state with the combined data
      }
    } catch (error) {
      console.error('Error fetching catalog data:', error);
    }
  };

  const handleCheckboxChange = (index: number, checked: boolean) => {
    setCategoriesData((prevCategories) =>
      prevCategories.map((field, i) => {
        const updatedField = i === index ? { ...field, checked } : field;
        return updatedField;
      })
    );
  };

  useEffect(() => {
    if (initialValues) {
      handleInputChange('name', initialValues.name);
      handleInputChange('description', initialValues.description);
      getProductHeader(initialValues.productTemplateId);
    }
  }, [initialValues]);
  return (
    <Drawer
      title={title}
      open={open}
      onClose={handleClose}
      anchor="right"
      classes={{ paper: classes.createFormSideBar }}
      sx={{
        zIndex: 1300,
        '& .MuiDrawer-paper': {
          width: '40%',
        },
      }}>
      <Box className="ticketBody">
        <Typography variant="h4" component="h4">
          {title}
        </Typography>
        <Box>
          <Formik
            initialValues={{
              name: cateFields.name || '',
              description: cateFields.description || '',
              // checkboxes: categoriesData,
              checkboxes: categoriesData.map((field) => ({
                label: field.label,
                checked: field.checked,
                inputType: field.inputType,
              })),
            }}
            validationSchema={validationSchema}
            onSubmit={async (values) => {
              // const checkedValues = values.checkboxes.filter((checkbox: any) => checkbox.checked);

              const checkedValues: any = values.checkboxes
                .map((checkbox, index) => ({
                  ...categoriesData[index],
                  checked: checkbox.checked,
                }))
                .filter((item) => item.checked);
              console.log('checkedValues:', checkedValues);

              const payload: any = {
                name: values.name,
                description: values.description,
                productTemplate: checkedValues.map((field, position) => ({
                  name: field.label,
                  fieldType: field.inputType,
                  isMandatory: field.isMandatory,
                  unit: 'string',
                  position: field.index,
                })),
              };
              console.log('Generated Payload:', payload);

              await onSubmit(payload);
              // handleClose()
            }}
            enableReinitialize
          // validateOnChange={false}
          >
            {({ handleSubmit, errors, touched }) => (
              <Form onSubmit={handleSubmit}>
                <Field
                  name="name"
                  as={TextField}
                  label="Name"
                  fullWidth
                  margin="normal"
                  value={cateFields.name}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleInputChange('name', e.target.value)
                  }
                  error={touched.name && Boolean(errors.name)}
                  helperText={touched.name && errors.name}
                />
                <Field
                  name="description"
                  as={TextField}
                  label="Description"
                  fullWidth
                  margin="normal"
                  value={cateFields.description}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleInputChange('description', e.target.value)
                  }
                // error={touched.description && Boolean(errors.description)}
                // helperText={touched.description && errors.description}
                />

                <Divider />

                {/* Checkboxes Section */}

                {!editCategory && (
                  <>
                    <Box className="CheckboxesSection">
                      <Box className="CheckboxesSection">
                        <Grid container spacing={2}>
                          {categoriesData.map((field, index) => (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              key={field.label}
                              className={
                                index === 0 || index === 1 ? 'skuName' : ''
                              }>
                              {' '}
                              {/* Adjust grid size for two columns */}
                              <Field name={`checkboxes.${index}.checked`}>
                                {({ field: formField, form }: any) => (
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        {...formField}
                                        checked={formField.value}
                                        onChange={(e) => {
                                          form.setFieldValue(
                                            `checkboxes.${index}.checked`,
                                            e.target.checked
                                          );
                                          handleCheckboxChange(
                                            index,
                                            e.target.checked
                                          );
                                        }}
                                        color="primary"
                                        disabled={
                                          field.index === 0 || field.index === 1
                                        }
                                      />
                                    }
                                    label={field.label}
                                  />
                                )}
                              </Field>
                            </Grid>
                          ))}
                        </Grid>
                      </Box>
                    </Box>
                  </>
                )}

                {editCategory && (
                  <>
                    <Box className="CheckboxesSection">
                      <Box className="BoxText">
                        <p className="heading">Selected options</p>
                        <p className="description">
                          Unselect options that are not applicable{' '}
                        </p>
                      </Box>
                      <Grid container spacing={2}>
                        {categoriesData
                          .filter((field) => field.checked === true)
                          .map((field, index) => (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              key={field.label}
                              className={
                                index === 0 || index === 1 ? 'skuName' : ''
                              }>
                              <Field
                                name={`checkboxes[${index}].checked`}
                                type="checkbox">
                                {({ field: formField, form }: any) => (
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        {...formField}
                                        checked={field.checked}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            field.index,
                                            e.target.checked
                                          )
                                        }
                                        color="primary"
                                        disabled={
                                          field.index === 0 || field.index === 1
                                        }
                                      />
                                    }
                                    label={field.label}
                                  />
                                )}
                              </Field>
                            </Grid>
                          ))}
                      </Grid>
                    </Box>
                    <Box className="CheckboxesSection">
                      <Box className="BoxText">
                        <p className="heading">unselected options</p>
                        <p className="description">
                          Select options that are applicable{' '}
                        </p>
                      </Box>
                      <Grid container spacing={2}>
                        {/* {categoriesData
                          .filter((field) => field.checked === false)
                          .map((field, index) => (
                            <Grid item xs={12} sm={12} key={field.label}>
                              <Field
                                name={`checkboxes[${index}].checked`}
                                type="checkbox">
                                {({ field: formField, form }: any) => (
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        {...formField}
                                        checked={field.checked}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            field.index,
                                            e.target.checked
                                          )
                                        }
                                        color="primary"
                                      />
                                    }
                                    label={field.label}
                                  />
                                )}
                              </Field>
                            </Grid>
                          ))} */}

                        {categoriesData.filter(
                          (field) => field.checked === false
                        ).length > 0 ? (
                          categoriesData
                            .filter((field) => field.checked === false)
                            .map((field, index) => (
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                key={field.label}
                                className={
                                  index === 0 || index === 1 ? 'skuName' : ''
                                }>
                                <Field
                                  name={`checkboxes[${index}].checked`}
                                  type="checkbox">
                                  {({ field: formField }) => (
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          {...formField}
                                          checked={field.checked}
                                          onChange={(e) =>
                                            handleCheckboxChange(
                                              field.index,
                                              e.target.checked
                                            )
                                          }
                                          color="primary"
                                        />
                                      }
                                      label={field.label}
                                    />
                                  )}
                                </Field>
                              </Grid>
                            ))
                        ) : (
                          <p className="description noData">No data</p>
                        )}
                      </Grid>
                    </Box>
                  </>
                )}

                <Box className="customFieldSection">
                  <Divider />

                  <Grid
                    container
                    spacing={2}
                    sx={{ marginTop: 1 }}
                    className="customField">
                    <Grid item xs={12}>
                      <TextField
                        label="Title"
                        fullWidth
                        value={customField.title}
                        onChange={(e) =>
                          setCustomField({
                            ...customField,
                            title: e.target.value,
                          })
                        }
                        inputProps={{ maxLength: 55 }}
                        error={customField.title.length > 50}
                        helperText={
                          customField.title.length > 50
                            ? 'Title must not exceed 50 characters'
                            : ''
                        }
                      />
                    </Grid>
                    <Grid item xs={12} className="selectField">
                      <FormControl fullWidth>
                        <InputLabel>Input Type</InputLabel>
                        <Select
                          value={customField.inputType}
                          onChange={(e) =>
                            setCustomField({
                              ...customField,
                              inputType: e.target.value,
                            })
                          }>
                          <MenuItem value="String">Text</MenuItem>
                          <MenuItem value="email">Email</MenuItem>
                          <MenuItem value="int">Number</MenuItem>
                          <MenuItem value="double">Decimal Number</MenuItem>
                          {/* <MenuItem value="People">People</MenuItem> */}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} className="selectField">
                      <FormControl fullWidth>
                        <InputLabel>Mandatory</InputLabel>
                        <Select
                          value={customField.mandatory}
                          onChange={(e) =>
                            setCustomField({
                              ...customField,
                              mandatory: e.target.value,
                            })
                          }>
                          <MenuItem value="Yes">Yes</MenuItem>
                          <MenuItem value="No">No</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Box sx={{ marginTop: 2 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={addCustomField}
                      className="addCustomFieldBT">
                      <span className="plus" style={{ marginRight: '8px' }}>
                        +{' '}
                      </span>{' '}
                      Add Custom Field
                    </Button>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    marginTop: 3,
                  }}>
                  <Button
                    type="button"
                    variant="outlined"
                    color="secondary"
                    onClick={handleClose}
                    sx={{ marginRight: 1 }}>
                    Cancel
                  </Button>
                  <Button type="submit" variant="contained" color="secondary">
                    Done
                  </Button>
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
      </Box>
    </Drawer>
  );
}
